import CustomerService from '../api/customerService';
import {getAdjustedPrice, logger} from '../utilities';

const LOG_PREFIX = '[loadPreviousCart.js]';

export const loadPreviousCart = async (cart, company, client) => {
    logger.debug(LOG_PREFIX, '.loadPreviousCart()', {cart, company, client});

    if (client.job === 'none') { // todo -- test
        return;
    }
    let salesData = await CustomerService.getSalesData(client.account, client.job);
    logger.debug(LOG_PREFIX, '.loadPreviousCart().retrieved', {salesData, cart});

    salesData = salesData.filter(s => ((s.details.client.location === client.location) || (s.details.client.location == null)));
    if (!salesData || !salesData.length || !salesData[0].details || !salesData[0].details.cart) {
        return;
    }

    logger.debug(LOG_PREFIX, '.loadPreviousCart().filtered', {salesData, cart});


    let previousCart = salesData[0].details.cart;
    logger.debug(LOG_PREFIX, '.loadPreviousCart().found', {previousCart, cart});

    let keys = ['previously_accepted', 'previously_purchased'];

    // go through all of the historic cart data
    keys.forEach((key) => {
        logger.debug(LOG_PREFIX, `.loadPreviousCart().parsing.${key}`, {previousCart, cart});
        cart[key] = previousCart[key] ? Object.assign({
            offerings: [],
            quantity: {},
            total: 0
        }, previousCart[key]) : {offerings: [], quantity: {}, total: 0};
    });
    logger.debug(LOG_PREFIX, '.loadPreviousCart().parsed', {previousCart, cart});

    // go through each of the items that were in the last "sale"
    previousCart.accepted.forEach(o => {

        let classification = 'previously_accepted';
        if (previousCart.paid && previousCart.paid.length > 0 && previousCart.paid.indexOf(o.id) >= 0) {
            // this has been classified as "paid"
            classification = 'previously_purchased';
        }

        // offering list
        if (cart[classification] && cart[classification].offerings && cart[classification].offerings.map(o => o.id).indexOf(o.id) === -1) {
            // item isn't found in the[classification] offerings list, so we should add it
            let offering = previousCart.accepted.find(x => x.id === o.id);
            cart[classification].offerings.push(offering);
        }

        let q = {}; //quantity
        if (cart[classification].quantity && cart[classification].quantity[o.id] >= 1) {
            // qty already exists for this item, add to it rather than replacing
            q[o.id] = cart[classification].quantity[o.id] + previousCart.quantity[o.id];
        } else {
            q[o.id] = previousCart.quantity[o.id];
        }
        // finally set the quantity to be correct
        cart[classification].quantity = Object.assign(cart[classification].quantity, q);

    });

    // update the totals to match the qty and offerings recalled from previous sales
    keys.forEach((key) => {
        let t = 0;
        cart[key].offerings.forEach(o => {
            t += getAdjustedPrice(o, client, company) * cart[key].quantity[o.id];
        });
        cart[key].total = t;
    });
    logger.debug(LOG_PREFIX, '.loadPreviousCart().final cart', {cart});
    return (cart);
};

export const sumPreviousCart = (cart) => {
    logger.debug(LOG_PREFIX, '.sumPreviousCart()', {cart});
    let acceptedQuantity = cart.previously_accepted.quantity || {};
    let purchasedQuantity = cart.previously_purchased.quantity || {};
    let acceptedSum = Object.values(acceptedQuantity).reduce((sum, quantity) => (sum + parseInt(quantity)), 0);
    let purchasedSum = Object.values(purchasedQuantity).reduce((sum, quantity) => (sum + parseInt(quantity)), 0);
    return acceptedSum + purchasedSum;
};

export const uniquePreviousItems = (cart) => {
    logger.debug(LOG_PREFIX, '.uniquePreviousItems()', {cart});
    let acceptedQuantity = cart.previously_accepted.quantity || {};
    let purchasedQuantity = cart.previously_purchased.quantity || {};
    return Object.keys(acceptedQuantity).length + Object.keys(purchasedQuantity).length;
};

